<!--
 * @Description: 专题页管理入口
 * @Author: wuxuebing
 * @Date: 2024-07-10 08:59:39
 * @LastEditors: wuxuebing
 * @LastEditTime: 2024-07-10 09:34:23
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\topic-page-management\index.vue
-->

<template>
  <transition name="fade" mode="out-in">
    <!-- 用做缓存页面 -->
    <keep-alive :include="cachedViews">
      <router-view :key="key"/>
    </keep-alive>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "",
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapState("tags", {
      cachedViews: (state) => state.cacheTags,
    }),
    key() {
      return this.$route.name;
    },
  },
};
</script>

<style scoped lang="less">
</style>